import { CommonModule } from '@angular/common';
import { Component, NgModule } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { DxFormModule } from 'devextreme-angular/ui/form';
import { DxButtonModule } from 'devextreme-angular/ui/button';
import { DxLoadIndicatorModule } from 'devextreme-angular/ui/load-indicator';
import notify from 'devextreme/ui/notify';
import { AuthService } from '../../services';
import { DxTextBoxModule } from 'devextreme-angular';
import { UserLoginRequest } from '../../../classes/infrastructure/request_response/userloginrequest';
import { isNullOrUndefined } from '../../../../tools';
import { UIUtils } from '../../../services/uiutils.service';
import { ServerCommunicatorService } from '../../../services/server-communicator.service';
import { AppStateManageService } from '../../../services/app-state-manage.service';
import { PasswordFlowMode } from '../../../services/passwordflowmode';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../../services/language.service';


@Component({
  selector: 'app-forgot-password-form',
  templateUrl: './forgot-password-form.component.html',
  styleUrls: ['./forgot-password-form.component.scss'],
  standalone: false
})
export class ForgotPasswordFormComponent {
  loading = false;
  formData: any = { email: "", password: "" };
  useSubmitBehavior: boolean = true


  constructor(private authService: AuthService, private router: Router, private uiUtils: UIUtils, private servercommunicator: ServerCommunicatorService, private appStateManage: AppStateManageService,
    public langService: LanguageService,
        private translate: TranslateService
  ) { }

  // passwordMode = 'password';
  passwordMode!: PasswordFlowMode;
  isEmailReadonly = false;
  titleText = '';
  subtitleText = '';

  ngOnInit() {
    const mode = this.appStateManage.getPasswordFlowMode();

    this.passwordMode = mode ?? PasswordFlowMode.FORGOT;

    // if (this.passwordMode === PasswordFlowMode.EXPIRED) {
    //   this.titleText = 'Password Expired';
    //   this.subtitleText =
    //     'Your password has expired. Please verify your email to continue.';

    //   this.formData.email =
    //     this.appStateManage.StorageKey.getItem('Email') ?? '';

    //   this.isEmailReadonly = true;
    // } else {
    //   this.titleText = 'Forgot your Password?';
    //   this.subtitleText =
    //     'Enter your Email ID so that we can send you password reset link';

    //   this.isEmailReadonly = false;
    // }

    const isMr = this.langService.currentLang === 'mr';

  if (this.passwordMode === PasswordFlowMode.EXPIRED) {
    this.titleText = isMr ? 'पासवर्ड कालबाह्य झाला आहे' : 'Password Expired';

    this.subtitleText = isMr
      ? 'तुमचा पासवर्ड कालबाह्य झाला आहे. पुढे जाण्यासाठी कृपया तुमचा ईमेल तपासा.'
      : 'Your password has expired. Please verify your email to continue.';

    this.formData.email =
      this.appStateManage.StorageKey.getItem('Email') ?? '';

    this.isEmailReadonly = true;
  } else {
    this.titleText = isMr
      ? 'पासवर्ड विसरलात?'
      : 'Forgot your Password?';

    this.subtitleText = isMr
      ? 'तुमचा ईमेल आयडी टाका, आम्ही तुम्हाला पासवर्ड रीसेट लिंक पाठवू'
      : 'Enter your Email ID so that we can send you password reset link';

    this.isEmailReadonly = false;
  }
  }

  // old implementation of forgot password
  // ForgetPassword = async () => {
  //   this.appStateManage.StorageKey.setItem('Email', this.formData.email)
  //   let body = {
  //     email_id : this.formData.email,
  //   };
  //   const response = await this.servercommunicator.FetchRequestForForgotPassword(
  //     'generateuserotp',
  //     body
  //   );
  //   console.log('response :', response);
  //   if (!response.successful) {
  //     await this.uiUtils.showErrorMessage('Error', response.message);
  //     return;
  //   } else {
  //     await this.uiUtils.showSuccessToster(
  //       'Please Check Your Mail, OTP Send On Your Email Id'
  //     );
  //     await this.router.navigate(['/otp-verification']);
  //   }
  // };

    // new implementation of forgot password with loading state and better error handling
  ForgetPassword = async () => {
  // ✅ Validate before calling API
  if (this.formData.email.trim() === "") {
    await this.uiUtils.showErrorMessage("Error", "Please enter your email ID");
    return;
  }

  this.loading = true; // ✅ show loader
  try {
    this.appStateManage.StorageKey.setItem("Email", this.formData.email);

    const response = await this.servercommunicator.FetchRequestForForgotPassword(
      "generateuserotp",
      { email_id: this.formData.email }
    );

    if (!response.successful) {
      await this.uiUtils.showErrorMessage("Error", response.message);
      return;
    }

    await this.uiUtils.showSuccessToster(
      "Please Check Your Mail, OTP Sent On Your Email ID"
    );
    await this.router.navigate(["/otp-verification"]);

  } finally {
    this.loading = false; // ✅ always reset loader
  }
};


  NavigateToLogin = () => {
    this.router.navigate(['login-form']);
  }
}
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    DxFormModule,
    DxLoadIndicatorModule,
    DxButtonModule,
    DxFormModule,
    DxTextBoxModule,
    DxButtonModule,
  ],
  declarations: [ForgotPasswordFormComponent],
  exports: [ForgotPasswordFormComponent]
})
export class ForgotPasswordFormModule { }